module.exports = __webpack_public_path__ + "static/media/RSAC.d2ffdc99.jpg";